import { types } from '../index';
import firebaseDB from '@src/firebase/database';
import { FirebaseEffects } from './FirebaseEffects';
import FirebaseListeners from './FirebaseListeners';

const logger = Logger.get( 'analytics' );


const FirebaseMiddleware = ( store ) => ( next ) => ( action ) => {
   // logger.log( action );
    switch ( action?.type ){
        case types.user.DataSuccess:
            const subscriberId = action.payload?.subscriberid;
            firebaseDB.setSubscriberId( subscriberId );
            break ;
        case types.config.Success:
            const vendorId = action.payload?.vendorDetails.vendorId ;
            firebaseDB.setVendorId( vendorId );
            break ;
        default: break ;
    }

    FirebaseListeners( store, action );
    FirebaseEffects( store, action );

    return next( action );
}

export default FirebaseMiddleware ;